export const TEXT_INPUT_REGEX = /^(?=.*\p{L})[\p{L}\s,'.-]+$/giu;
export const TEXT_AND_NUMBER_INPUT_REGEX =
  /^(?=.*\p{L}|\p{N})[\p{L}\p{N}\s,'’&#()./\\-]+$/giu;
export const CITY_REGEX = /^(?=.*\p{L}|\p{N})[\p{L}\p{N}\s,'.-]+$/giu;
export const EMAIL_REGEX = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
export const PHONE_NUMBER_WITH_PREFIX_REGEX = /^\+[0-9]{9,14}$/;
export const PHONE_NUMBER_PRINCIPAL_REGEX = /^[0-9]{7,12}$/;
export const VAT_NUMBER_REGEX = /^[a-z0-9 ,.'-]+$/i;
